// extracted by mini-css-extract-plugin
export default {"container":"layouts_container__c70NZ","sidebar":"layouts_sidebar__NCCNC","navbar":"layouts_navbar__REiU1","main":"layouts_main__u-xXS"};